"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createMediaItem = void 0;
var _createListOfProducts = require("./createListOfProducts");
const createMediaItem = item => ({
  id: item.id,
  mediaType: item.type.toLocaleLowerCase() === 'video' ? 'video' : 'image',
  isInstagram: item.original_source.includes('instagram'),
  originalSource: item.original_source,
  source: item.source,
  caption: item.caption,
  videoUrl: item.video_url ?? '',
  originalImageWidth: item.original_image_width,
  originalImageHeight: item.original_image_height,
  images: {
    mobile: item.images.mobile,
    normal: item.images.normal,
    original: item.images.original
  },
  uploader: {
    id: item._embedded.uploader.id,
    name: item._embedded.uploader.name
  },
  reportPhotoUrl: item._forms.report.action.href,
  products: (0, _createListOfProducts.createListOfProducts)(item._embedded['streams:all']._embedded.stream)
});
exports.createMediaItem = createMediaItem;
